import { createStore } from "vuex";

export default createStore({
  state: {
    savedFaces: [],
    currentFace: null,
  },
  mutations: {
    saveFace(state, faceData) {
      state.savedFaces.push({
        id: Date.now(),
        data: faceData,
        timestamp: new Date().toISOString(),
      });
    },
    setCurrentFace(state, faceData) {
      state.currentFace = faceData;
    },
    removeFace(state, id) {
      state.savedFaces = state.savedFaces.filter((face) => face.id !== id);
    },
  },
  actions: {
    saveFace({ commit }, faceData) {
      commit("saveFace", faceData);
    },
  },
  getters: {
    getSavedFaces: (state) => state.savedFaces,
  },
});
